if (typeof ProductPage !== 'function') {

	class ProductPage extends HTMLElement {

		constructor() {

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if (this.productSlider) {

				const productGaleryThumbnails = this.querySelector(
					'.product-gallery__thumbnails-holder'
				);

				if (this.querySelector('.product-gallery__thumbnails .thumbnail')) {

					this.querySelectorAll(
						'.product-gallery__thumbnails .thumbnail'
					).forEach((elm, i) => {

						if (i == 0) {
							elm.classList.add('active');
						}

						elm.addEventListener('click', e => {

							if (this.productSlider.sliderEnabled) {

								this.productSlider.changeSlide(
									e.currentTarget.dataset.index
								);

							} else {

								window.scrollTo({
									top:
										this.productGallery.querySelector(
											`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`
										).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});

								this.thumbnailNavigationHelper(
									e.currentTarget.dataset.index
								);
							}

							this._pauseAllMedia();

							this._playMedia(
								this.productGallery.querySelector(
									`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`
								)
							);

							if (productGaleryThumbnails) {
								productGaleryThumbnails.scrollTo({
									left: elm.offsetLeft - 50,
									behavior: 'smooth'
								});
							}
						});
					});

					this.productSlider.addEventListener('change', e => {
						this.thumbnailNavigationHelper(e.target.index);
					});
				}

				this.productSlider.addEventListener('navigation', e => {

					const currentMedia = this.productGallery.querySelector(
						`.product-gallery-item[data-index="${e.target.index}"]`
					);

					if (currentMedia) {
						this._playMedia(currentMedia);
					}
				});

				this.productSlider.addEventListener('change', e => {

					this._pauseAllMedia();

					const currentMedia = this.productGallery.querySelector(
						`.product-gallery-item[data-index="${e.target.index}"]`
					);

					if (
						currentMedia &&
						currentMedia.dataset.productMediaType == 'model'
					) {

						if (this.xrButton) {
							this.xrButton.setAttribute(
								'data-shopify-model3d-id',
								currentMedia.dataset.mediaId
							);
						}

						setTimeout(() => {

							const sliderHolder = this.productSlider.querySelector(
								'.css-slider-holder'
							);

							if (sliderHolder) {
								sliderHolder.classList.add(
									'css-slider--disable-dragging'
								);
							}

						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', () => {

					if (this.firstProductGalleryIndex) {
						this.productSlider.changeSlide(
							this.firstProductGalleryIndex,
							'auto'
						);
					}

					const productSlides = this.productSlider.querySelectorAll(
						'.product-gallery-item'
					);

					const productFigures = this.querySelectorAll(
						'.apply-gallery-animation'
					);

					this.productSlider.addEventListener('scroll', () => {

						const scrollX = -this.productSlider.element.scrollLeft;

						productSlides.forEach((slide, i) => {

							const media = productFigures[i];

							if (media) {
								media.style.transform =
									`translateX(${(slide.offsetLeft + scrollX) * -1 / 3}px)`;
							}
						});
					});
				});
			}

			// Product variant event listener

			this.productVariants = this.querySelector('product-variants');

			if (this.productVariants) {

				this.productVariants.addEventListener(
					'VARIANT_CHANGE',
					this.onVariantChangeHandler.bind(this)
				);
			}

			// Show cart drawer when element is added to cart

			if (
				!document.body.classList.contains('template-cart') &&
				KROWN.settings.cart_action == 'overlay'
			) {

				let addToCartEnter = false;

				const addToCartButton = this.querySelector(
					'[data-js-product-add-to-cart]'
				);

				if (addToCartButton) {

					addToCartButton.addEventListener('keyup', e => {

						if (e.keyCode == window.KEYCODES.RETURN) {
							addToCartEnter = true;
						}
					});
				}

				const productForm = this.querySelector(
					'[data-js-product-form]'
				);

				if (productForm) {

					productForm.addEventListener('add-to-cart', () => {

						const cartSidebar = document.getElementById(
							'site-cart-sidebar'
						);

						if (cartSidebar) {
							cartSidebar.show();
						}

						const cartRecommendations = document.getElementById(
							'cart-recommendations'
						);

						if (cartRecommendations) {
							cartRecommendations.generateRecommendations();
						}

						if (addToCartEnter) {

							setTimeout(() => {

								const closeButton = document.querySelector(
									'#site-cart-sidebar [data-js-close]'
								);

								if (closeButton) {
									closeButton.focus();
								}

							}, 200);
						}
					});
				}
			}

			// Check for models

			const models = this.querySelectorAll('product-model');

			if (models.length > 0) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector(
					'.product-gallery__view-in-space'
				);
			}

			// Hide buy now button if stock disabled

			const addToCartButton = this.querySelector(
				'[data-js-product-add-to-cart]'
			);

			if (addToCartButton) {

				const productForm = this.querySelector('product-form');

				if (productForm) {

					if (addToCartButton.classList.contains('disabled')) {
						productForm.classList.add('disable-buy-button');
					} else {
						productForm.classList.remove('disable-buy-button');
					}

					const buyObserver = new MutationObserver(() => {

						if (addToCartButton.classList.contains('disabled')) {
							productForm.classList.add('disable-buy-button');
						} else {
							productForm.classList.remove('disable-buy-button');
						}
					});

					buyObserver.observe(addToCartButton, {
						attributes: true,
						childList: false,
						subtree: false
					});
				}
			}

			// Price elements

			this.priceCompact = this.querySelector(
				'[data-js-product-price-compact]'
			);

			this.priceExtended = this.querySelector(
				'[data-js-product-price-extended]'
			);

			if (this.priceCompact) {

				this.priceCompact.priceOriginal =
					this.priceCompact.querySelector(
						'[data-js-product-price-original]'
					);

				this.priceCompact.priceCompare =
					this.priceCompact.querySelector(
						'[data-js-product-price-compare]'
					);

				this.priceCompact.priceUnit =
					this.priceCompact.querySelector(
						'[data-js-product-price-unit]'
					);

				this.priceCompact.priceDiscount =
					this.priceCompact.querySelector(
						'[data-js-product-price-discount]'
					);
			}

			if (this.priceExtended) {

				this.priceExtended.priceOriginal =
					this.priceExtended.querySelector(
						'[data-js-product-price-original]'
					);

				this.priceExtended.priceCompare =
					this.priceExtended.querySelector(
						'[data-js-product-price-compare]'
					);

				this.priceExtended.priceUnit =
					this.priceExtended.querySelector(
						'[data-js-product-price-unit]'
					);

				this.priceExtended.priceDiscount =
					this.priceExtended.querySelector(
						'[data-js-product-price-discount]'
					);
			}

			// Initial variant render

			if (this.productVariants) {

				this.onVariantChangeHandler({
					target: this.productVariants
				});
			}
		}

		thumbnailNavigationHelper(index = 0) {

			this.querySelectorAll(
				'.product-gallery__thumbnails .thumbnail'
			).forEach((elm, i) => {

				if (i == index) {
					elm.classList.add('active');
				} else {
					elm.classList.remove('active');
				}
			});
		}

		updateDiscountBadge(priceContainer, variant) {

			if (
				!priceContainer ||
				!priceContainer.priceDiscount
			) {
				return;
			}

			const discountBadge = priceContainer.priceDiscount;

			if (
				!variant ||
				!variant.compare_at_price ||
				Number(variant.compare_at_price) <= Number(variant.price)
			) {

				discountBadge.textContent = '';
				discountBadge.style.display = 'none';
				discountBadge.removeAttribute('aria-label');

				return;
			}

			const price = Number(variant.price);
			const compareAtPrice = Number(variant.compare_at_price);

			const discountPercentage = Math.round(
				((compareAtPrice - price) * 100) / compareAtPrice
			);

			discountBadge.textContent = `-${discountPercentage}%`;
			discountBadge.style.display = 'inline-flex';

			discountBadge.setAttribute(
				'aria-label',
				`${discountPercentage}% de descuento`
			);
		}

		onVariantChangeHandler(e) {

			const variant = e.target.currentVariant;

			if (variant) {

				// Image handling

				if (
					variant.featured_media != null &&
					this.productGallery
				) {

					const variantImg = this.productGallery.querySelector(
						'.product-gallery-item[data-media-id="' +
						variant.featured_media.id +
						'"]'
					);

					if (variantImg) {

						if (
							this.productGallery.classList.contains(
								'product-gallery--slider'
							) ||
							(
								this.productGallery.classList.contains(
									'product-gallery--scroll'
								) &&
								window.innerWidth < 1024
							)
						) {

							const gallerySlider =
								this.productGallery.querySelector('css-slider');

							if (
								gallerySlider &&
								gallerySlider.sliderEnabled
							) {

								gallerySlider.changeSlide(
									variantImg.dataset.index
								);

							} else {

								this.firstProductGalleryIndex =
									variantImg.dataset.index;
							}

						} else {

							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

				// Refresh pickup availability widgets

				if (
					this.pickupAvailabilityCompact &&
					this.pickupAvailabilityCompact.classList.contains('active')
				) {

					this.pickupAvailabilityCompact.style.display = 'block';
					this.pickupAvailabilityCompact.fetchAvailability(
						variant.id
					);
				}

				if (
					this.pickupAvailabilityExtended &&
					this.pickupAvailabilityExtended.classList.contains('active')
				) {

					this.pickupAvailabilityExtended.style.display = 'block';
					this.pickupAvailabilityExtended.fetchAvailability(
						variant.id
					);
				}

			} else {

				if (
					this.pickupAvailabilityCompact &&
					this.pickupAvailabilityCompact.classList.contains('active')
				) {

					this.pickupAvailabilityCompact.style.display = 'none';
				}

				if (
					this.pickupAvailabilityExtended &&
					this.pickupAvailabilityExtended.classList.contains('active')
				) {

					this.pickupAvailabilityExtended.style.display = 'none';
				}
			}

			// Update compact price

			if (this.priceCompact) {

				if (!variant) {

					if (this.priceCompact.priceOriginal) {
						this.priceCompact.priceOriginal.innerHTML = '';
					}

					if (this.priceCompact.priceCompare) {
						this.priceCompact.priceCompare.innerHTML = '';
					}

					if (this.priceCompact.priceUnit) {
						this.priceCompact.priceUnit.innerHTML = '';
					}

				} else {

					if (this.priceCompact.priceOriginal) {

						this.priceCompact.priceOriginal.innerHTML =
							this.productVariants._formatMoney(
								variant.price,
								KROWN.settings.shop_money_format
							);
					}

					if (this.priceCompact.priceCompare) {

						if (
							variant.compare_at_price &&
							variant.compare_at_price > variant.price
						) {

							this.priceCompact.priceCompare.innerHTML =
								this.productVariants._formatMoney(
									variant.compare_at_price,
									KROWN.settings.shop_money_format
								);

						} else {

							this.priceCompact.priceCompare.innerHTML = '';
						}
					}

					if (this.priceCompact.priceUnit) {

						if (variant.unit_price_measurement) {

							this.priceCompact.priceUnit.innerHTML = `
								${this.productVariants._formatMoney(
									variant.unit_price,
									KROWN.settings.shop_money_format
								)} /
								${
									variant.unit_price_measurement.reference_value != 1
										? variant.unit_price_measurement.reference_value + ' '
										: ''
								}
								${variant.unit_price_measurement.reference_unit}
							`;

						} else {

							this.priceCompact.priceUnit.innerHTML = '';
						}
					}
				}

				this.updateDiscountBadge(
					this.priceCompact,
					variant
				);
			}

			// Update extended price

			if (this.priceExtended) {

				if (!variant) {

					if (this.priceExtended.priceOriginal) {
						this.priceExtended.priceOriginal.innerHTML = '';
					}

					if (this.priceExtended.priceCompare) {
						this.priceExtended.priceCompare.innerHTML = '';
					}

					if (this.priceExtended.priceUnit) {
						this.priceExtended.priceUnit.innerHTML = '';
					}

				} else {

					if (this.priceExtended.priceOriginal) {

						this.priceExtended.priceOriginal.innerHTML =
							this.productVariants._formatMoney(
								variant.price,
								KROWN.settings.shop_money_format
							);
					}

					if (this.priceExtended.priceCompare) {

						if (
							variant.compare_at_price &&
							variant.compare_at_price > variant.price
						) {

							const comparePrice =
								this.productVariants._formatMoney(
									variant.compare_at_price,
									KROWN.settings.shop_money_format
								);

							const savingPrice =
								this.productVariants._formatMoney(
									variant.compare_at_price - variant.price,
									KROWN.settings.shop_money_format
								);

							this.priceExtended.priceCompare.innerHTML =
								`<span>${comparePrice}</span>` +
								`<span>${
									KROWN.settings.locales.product_compare_price.replace(
										'$SAVE_PRICE',
										savingPrice
									)
								}</span>`;

						} else {

							this.priceExtended.priceCompare.innerHTML = '';
						}
					}

					if (this.priceExtended.priceUnit) {

						if (variant.unit_price_measurement) {

							this.priceExtended.priceUnit.innerHTML = `
								${this.productVariants._formatMoney(
									variant.unit_price,
									KROWN.settings.shop_money_format
								)} /
								${
									variant.unit_price_measurement.reference_value != 1
										? variant.unit_price_measurement.reference_value + ' '
										: ''
								}
								${variant.unit_price_measurement.reference_unit}
							`;

						} else {

							this.priceExtended.priceUnit.innerHTML = '';
						}
					}
				}

				this.updateDiscountBadge(
					this.priceExtended,
					variant
				);
			}
		}

		_pauseAllMedia() {

			document.querySelectorAll(
				'.product-gallery .js-youtube'
			).forEach(video => {

				video.contentWindow.postMessage(
					'{"event":"command","func":"pauseVideo","args":""}',
					'*'
				);
			});

			document.querySelectorAll(
				'.product-gallery .js-vimeo'
			).forEach(video => {

				video.contentWindow.postMessage(
					'{"method":"pause"}',
					'*'
				);
			});

			document.querySelectorAll(
				'.product-gallery video'
			).forEach(video => video.pause());

			document.querySelectorAll(
				'.product-gallery product-model'
			).forEach(model => {

				if (model.modelViewerUI) {
					model.modelViewerUI.pause();
				}
			});
		}

		_playMedia(media) {

			if (!media) {
				return;
			}

			switch (media.dataset.productMediaType) {

				case 'video':

					if (media.querySelector('video')) {
						media.querySelector('video').play();
					}

					break;

				case 'external_video-youtube':

					if (media.querySelector('.js-youtube')) {

						media.querySelector(
							'.js-youtube'
						).contentWindow.postMessage(
							'{"event":"command","func":"playVideo","args":""}',
							'*'
						);
					}

					break;

				case 'external_video-vimeo':

					if (media.querySelector('.js-vimeo')) {

						media.querySelector(
							'.js-vimeo'
						).contentWindow.postMessage(
							'{"method":"play"}',
							'*'
						);
					}

					break;
			}
		}
	}

	if (typeof customElements.get('product-page') == 'undefined') {
		customElements.define('product-page', ProductPage);
	}
}